import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import CustomSpeedDialAction from 'components/FabComponent/CustomSpeedDialAction';
import messages from 'components/FabComponent/messages';
import {
  StyledDiv,
  StyledImg,
  StyledOrangeButton,
  StyledSpeedDial,
  StyledSpeedDialAction,
} from 'components/FabComponent/styles';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';
import { isReverse, translate } from 'helpers/intl';
import { AssuranceIcon } from 'images';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import pages from 'routes/pages';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      transform: 'translateZ(0px)',
      flexGrow: 2,
      marginRight: 100,
      marginLeft: 100,
    },
  }),
);

const actions = [
  {
    icon: 'fabMail',
    title: messages.contact,
    externalLink: 'https://www.sanlamallianz.ma/reclamation',
    label: "Besoin d'aide_Contactez nous",
  },

  {
    icon: 'fabPhone',
    title: messages.contacts_utils,
    link: pages.CONTACTS,
    label: "Besoin d'aide_contacts utiles",
  },
  {
    icon: 'fabAgent',
    title: messages.agent_title,
    link: pages.SERVICES,
    label: "Besoin d'aide_Localiser un agent",
  },
  {
    icon: 'fabQuestion',
    title: messages.faq,
    link: pages.FAQ,
    label: "Besoin d'aide_FAQ",
  },
].reverse();

const FabComponent = (props: { intl: IntlShape }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  /* istanbul ignore next */
  const handleOpen = () => {
    setOpen(true);
    GATracking.event(
      EVENT_CATEGORIES.LOGIN,
      EVENT_ACTION.HOVER,
      "Besoin d'aide (Page initial)",
    );
  };

  /* istanbul ignore next */
  const handleClose = () => {
    setOpen(false);
  };
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  return (
    <StyledDiv className={classes.root}>
      <StyledSpeedDial
        ariaLabel="besoin d'aide"
        direction={'up'}
        icon={
          <Grid>
            <StyledOrangeButton
              variant="contained"
              data-testid="besoin-aide"
              onClick={/* istanbul ignore next */ () => handleOpen()}
            >
              <Grid
                container
                justify="space-between"
                alignItems="center"
                xs={12}
              >
                <Grid item xs={reverse ? 1 : 2}>
                  <StyledImg
                    src={AssuranceIcon.helpIcon}
                    reverse={reverse}
                    alt="help-icon"
                  />
                </Grid>
                <Grid item xs={reverse ? 11 : 10}>
                  {translate({ ...messages.besoinAide }, props)}
                </Grid>
              </Grid>
            </StyledOrangeButton>
          </Grid>
        }
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {actions.map((action, index) => (
          <StyledSpeedDialAction
            key={index}
            icon={
              <CustomSpeedDialAction
                {...action}
                title={translate(action.title, props)}
              />
            }
            disableHoverListener={true}
            onClick={handleClose}
          ></StyledSpeedDialAction>
        ))}
      </StyledSpeedDial>
    </StyledDiv>
  );
};
export default injectIntl(FabComponent);
